import { useState } from 'react'
import { Alert, Button, Card, Form } from 'antd'
import { CronForm, TaskForm } from './Forms'
import { cleanUpNewTask, cleanUpEditedTask } from './helpers'
import { useRouteMatch, useHistory } from 'react-router-dom'

export default function Container ({ orchestrator }) {

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formSubmitError, setFormSubmitError] = useState(undefined)

  const history = useHistory()

  const { params: { spaceId, taskId }} = useRouteMatch()
  const [taskForm] = Form.useForm()
  const [cronForm] = Form.useForm()

  const handleSendCronFromData = async (fields, scheduleUid) => {
    const parsed = fields?.map((field) => {
      const { firstRun, runOnce, cron, uid } = field
      return {
        cronUid: uid,
        cron,
        firstRun: firstRun?.utc().valueOf()/1000 || -1,
        runOnce
      }
    })

    for (let item in parsed) {
      if (parsed[item].cronUid !== undefined) {
        await orchestrator.updateCron(parsed[item])
      } else {
        await orchestrator.addCron({ ...parsed[item], scheduleUid })
      }
    }
  }

  const handleSendTaskFormData = async (fields) => {
    let scheduleUid = undefined

    if (taskId === 'new') {
      const cleanedTaskData = await cleanUpNewTask(fields)
      scheduleUid = await orchestrator.schedule(cleanedTaskData)
    } else {
      const cleanedTaskData = await cleanUpEditedTask(taskId, fields)
      scheduleUid = taskId
      await orchestrator.updateSchedule({ scheduleUid, name: fields.name })
      await orchestrator.updateConfiguration(cleanedTaskData)
    }

    return scheduleUid
  }

  const onFinish = async () => {
    setIsSubmitting(true)
    try {
      const scheduleUid = await handleSendTaskFormData(taskForm.getFieldsValue())
      await handleSendCronFromData(cronForm.getFieldsValue().crons, scheduleUid)

      history.push({
        pathname: `/${ spaceId }/pipelines/tasks`,
        state: scheduleUid
      })
    } catch (error) {
      setFormSubmitError(error.message)
    }
    setIsSubmitting(false)
  }


  return (
    <Card style={{ margin: '20px' }}>
      <TaskForm
        form={taskForm}
        data-testid="task-form"
        orchestrator={orchestrator}
        onlyConfig={false}
      />
      <CronForm
        form={cronForm}
        data-testid="cron-form"
        orchestrator={orchestrator}
      />
      {
        formSubmitError &&
          <Form.Item>
            <Alert
              type="error"
              message="Encountered issues creating task"
              description={formSubmitError}
            />
          </Form.Item>
      }
      <Button
        data-testid="create-task"
        type="primary"
        disabled={isSubmitting}
        onClick={() => onFinish()}
      >
        { (taskId === 'new') ? "Create Task" : "Update Task" }
      </Button>
    </Card>
  );
}
